import React from 'react';
import StripeModal from '../Modal/StripeModal';

type AddNewPaymentProps = {
  mutate?: () => void;
};

export const AddNewPayment: React.FC<AddNewPaymentProps> = ({ mutate }) => {
  const [isStripeModalOpen, setIsStripeModalOpen] = React.useState(false);
  return <StripeModal mutate={mutate} modalStates={[isStripeModalOpen, setIsStripeModalOpen]} />;
};
